import { render, staticRenderFns } from "./product-drop-images.vue?vue&type=template&id=5785709b&scoped=true&"
import script from "./product-drop-images.vue?vue&type=script&lang=js&"
export * from "./product-drop-images.vue?vue&type=script&lang=js&"
import style0 from "./product-drop-images.vue?vue&type=style&index=0&id=5785709b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785709b",
  null
  
)

export default component.exports